/**
 * 홈 포털 위젯 쿼리 키·API 경로 공유 모듈.
 *
 * SSR 프리페치(entry-server.tsx)와 홈 위젯 컴포넌트가 반드시 같은 키/경로를 쓰도록
 * 한 곳에 모은다. (과거 SSR 이 구버전 키(['popular-facilities'] 등)를 시드해
 * 위젯이 서버 HTML 에서 '로딩 중'으로 남던 불일치의 재발 방지)
 */

/** 인기 시설 TOP 5 위젯 (PopularFacilities) 쿼리 키 */
export const HOME_POPULAR_FACILITIES_QUERY_KEY = ['home-popular-facilities'] as const

/** 실시간 HOT 시설 랭킹 위젯 (HotRankingWidget) 쿼리 키 */
export const HOME_HOT_RANKING_QUERY_KEY = ['home-hot-ranking'] as const

/** 실시간 HOT 위젯이 쓰는 평점 TOP5 API 경로 (apiClient 기준 상대 경로) */
export const HOME_TOP5_FACILITIES_PATH = '/facilities?page=0&size=5&sortBy=RATING'

/** 인기 시설 TOP5 — 북마크(찜) 많은 순 API 경로. List(data) 반환(content 아님). */
export const HOME_POPULAR_BY_BOOKMARK_PATH = '/facilities/popular?size=5'

/** 실시간 HOT 랭킹 — 행동 기반 점수 + 순위변동 API 경로. List(data) 반환(content 아님). */
export const HOME_HOT_RANKING_PATH = '/facilities/hot-ranking?size=5'

/**
 * 모바일 '근처 인기 시설' 쿼리 키 (HomePage MobilePortalHome).
 * 위치 미확보(초기 렌더·SSR) 시 lat/lng 는 null — SSR 시드는 반드시 (null, null) 키.
 */
export function mobilePopularQueryKey(lat: number | null, lng: number | null) {
  return ['mobile-popular', lat, lng] as const
}

/** 모바일 '근처 인기 시설' 위치 미확보 시 API 경로 (apiClient 기준 상대 경로) */
export const MOBILE_POPULAR_DEFAULT_PATH = '/facilities?page=0&size=8'

/** 커뮤니티 인기글 위젯 (CommunityHotPosts) — 보드 목록 쿼리 키 */
export const HOME_COMMUNITY_BOARDS_QUERY_KEY = ['home-community-boards'] as const

/** 커뮤니티 인기글 위젯 — 보드별 인기글 쿼리 키 */
export function homeCommunityHotQueryKey(slug: string | null, page: number) {
  return ['home-community-hot', slug, page] as const
}

/**
 * 커뮤니티 위젯 탭 정렬 — 글이 많은 게시판 우선, 동률은 displayOrder.
 * SSR 프리페치가 첫 탭(초기 노출 게시판)을 컴포넌트와 동일하게 결정하기 위해 공유한다.
 */
export function sortHomeCommunityTabs<T extends { postCount: number; displayOrder: number }>(
  boards: T[]
): T[] {
  return boards
    .slice()
    .sort((a, b) => b.postCount - a.postCount || a.displayOrder - b.displayOrder)
}
